export const colors: string[] = [
  "#ff2c2c",
  "#262626",
  "#2282fd",
  "#24ea24",
  "#fb9bac",
  "#ff8024",
  "#f94aff",
  "#0eb1c1",
];
